module.exports = __webpack_public_path__ + "static/media/6.f04b7d0a.png";